module.exports = __webpack_public_path__ + "static/media/4ODA19.369552d7.jpg";